import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withTranslation } from 'react-i18next'
import qs from 'qs'
import { animateScroll as scroll } from 'react-scroll'
import { Link } from 'react-router-dom'

import { getMoment } from '../../utils/dateTime'
import { getEmbedCodePlain, uuidv4 } from '../../utils/publisher'
import { getProjectEmbedCodeWithIFrame, getProjectEmbedCodeWithLoader } from '../../utils/embed' // for cdn

import Loader from '../../components/Loader'
import Toast from '../../common/components/Toast/Toast'
import ShareProjectModal from './components/modals/ShareProjectModal/ShareProjectModal'
import TrialProgressBanner from './components/TrialProgressBanner'

import { UTILS__ROUTER__add_query, UTILS__ROUTER__remove_query } from '../../utils/router'

import { API__PROJECTS, API__USER } from '../../api'

import { types_translations } from '../../utils/crutchTranslations'
import { DeleteProjectModal, MobileActionsModal } from './components/modals'
import { DraftsTab, PublishedTab } from './components/tabs'
import {
    USER__SET_NOTIFICATIONS,
    USER__SET_SUBSCRIPTION,
    USER__SET_SUBSCRIPTION_CONSTRAINTS,
    USER__SET_TRIAL_COUNT,
} from '../../store/actions'
import { TrialEndedModal } from '../../common/components/Modal/TrialEndedModal/TrialEndedModal'
import {
    NEW_SUB_TO_TRIAL,
    OLD_PAID_SUB_TO_TRIAL,
    OLD_SUB_TO_EDUCATION_FREE,
    OLD_SUB_TO_TRIAL,
    PRODUCT_LIST_PAID,
    TRIAL_ENDED_OR_SUB_TO_TRIAL,
    TRIAL_ENDED_PRODUCT_CODE,
    TRIAL_PRODUCT_CODE,
} from '../../common/constants/ProductConstants'
import TrialExtensionModal from '../../common/components/Modal/TrialExtensionModal/TrialExtensionModal'
import PROJECT_TYPES from '../../common/constants/ProjectTypes'

class MyProjects extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        const {
            user_subscription: userSubscription,
            user_notifications: userNotifications,
            user_details: userDetails,
        } = props

        const trialNotification = userNotifications.find(obj =>
            [OLD_SUB_TO_TRIAL, OLD_PAID_SUB_TO_TRIAL, NEW_SUB_TO_TRIAL].includes(obj.type),
        )
        this.state = {
            isLoading: true,

            actionLoading: {
                duplicateProject: false,
            },
            trialEndedModal: {
                isOpen: false,
            },
            educationModal: {
                isOpen: false,
            },
            publishModal: {
                isOpen: false,
                menu: null,
                title: '',
                data: {
                    projectUrl: '',
                    embedCode: '',
                    iframeCode: '',
                },
            },
            shareModal: {
                isOpen: false,
                menu: null,
                data: {
                    projectUrl: '',
                    embedCode: '',
                    iframeCode: '',
                },
            },

            tab: null,
            tabs: ['drafts', 'published'],

            projects: {
                drafts: {
                    isLoading: false,
                    count: 0,
                    pagination: {
                        initialPage: 0,
                        perPage: 10,
                        totalPages: 0,
                        offsetPages: 0,
                    },
                    filter: {
                        status: 'DRAFT',
                        sort: 'updated,desc',
                    },

                    content: [],
                },
                published: {
                    isLoading: false,
                    count: 0,
                    pagination: {
                        initialPage: 0,
                        perPage: 10,
                        totalPages: 0,
                        offsetPages: 0,
                    },
                    filter: {
                        status: 'PUBLISHED',
                        sort: 'updated,desc',
                    },
                    content: [],
                },
            },

            modal: {
                isOpen: false,
                name: '',
                data: null,
                isSuccess: false,
                isError: false,
                errorMessage: '',
            },

            deleteProjectAgreement: false,
            userNotifications: userNotifications,
            trialType: trialNotification && trialNotification.type,
            educationTransferNotification: userNotifications.find(obj => obj.type === OLD_SUB_TO_EDUCATION_FREE),
            userDetails: userDetails,
            isTrial:
                userNotifications.find(obj =>
                    [OLD_SUB_TO_TRIAL, NEW_SUB_TO_TRIAL, OLD_PAID_SUB_TO_TRIAL].includes(obj.type),
                ) || userSubscription.product.productCode === TRIAL_ENDED_PRODUCT_CODE,
            userId: userDetails.id,
            subscriptionId: userSubscription.id,
        }
        this.baseState = this.state
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    async componentDidMount() {
        this._isMounted = true
        // Check location state
        const { location, history, user_subscription: userSubscription } = this.props
        if (location.state) {
            const { action } = location.state
            if (action && action === 'editor--published') {
                const { note, data } = location.state
                await this.setState(prevState => ({
                    publishModal: {
                        ...prevState.publishModal,
                        isOpen: true,
                        title:
                            note === 'changes'
                                ? this.props.t('_pages._my_projects.project_changes_published')
                                : this.props.t('_pages._my_projects.project_published'),
                        data: {
                            ...prevState.publishModal.data,
                            projectUrl: data.projectUrl,
                            embedCode: data.embedCode,
                            iframeCode: data.iframeCode,
                        },
                    },
                }))
            }
            history.replace()
        }

        const {
            isTrial,
            trialType,
            trialTimeLeft,
            userNotifications,
            userDetails: { roleInProjectDto },
            educationTransferNotification,
        } = this.state
        if (isTrial && roleInProjectDto && trialType !== NEW_SUB_TO_TRIAL) {
            this.setState({
                trialEndedModal: {
                    isOpen: true,
                },
            })
        }

        if (trialTimeLeft && trialTimeLeft.time < 0) {
            const notification = userNotifications.find(obj => obj.type === TRIAL_ENDED_OR_SUB_TO_TRIAL)
            if (notification) {
                await API__USER.SET_NOTIFICATION_READ(notification.userId, notification.id)
            }
            this.setState({
                trialEndedModal: {
                    isOpen: true,
                },
            })
        }

        if (
            Object.values(PRODUCT_LIST_PAID).includes(userSubscription.product.productCode) &&
            [OLD_PAID_SUB_TO_TRIAL, OLD_SUB_TO_TRIAL].includes(trialType)
        ) {
            const trialNotifications = userNotifications.filter(obj =>
                [OLD_PAID_SUB_TO_TRIAL, OLD_SUB_TO_TRIAL].includes(obj.type),
            )
            if (trialNotifications.length > 0) {
                for (const notification of trialNotifications) {
                    await API__USER.SET_NOTIFICATION_READ(notification.userId, notification.id)
                    this.props.dispatch(USER__SET_NOTIFICATIONS(await API__USER.GET_NOTIFICATIONS(notification.userId)))
                }
                this.closeDetachedModal('trialEndedModal')
            }
        }

        if (educationTransferNotification) {
            this.setState({
                educationModal: {
                    isOpen: true,
                },
            })
        }

        try {
            await this.getProjectsCount()

            // Tabs
            const { tabs, projects } = this.state

            const queryParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
            const queryParamsTab = queryParams.tab
            if (typeof queryParamsTab !== 'undefined') {
                if (tabs.indexOf(queryParamsTab) !== -1) {
                    await this.setState({
                        tab: queryParamsTab,
                    })
                } else {
                    await this.setState({
                        tab: tabs[0],
                    })
                    UTILS__ROUTER__remove_query('tab', {
                        history: this.props.history,
                        location: this.props.location,
                    })
                }
            } else {
                if (projects.published.count > 0) {
                    const publishedTab = tabs[1]
                    await this.setState({
                        tab: publishedTab,
                    })
                    UTILS__ROUTER__add_query('tab', publishedTab, {
                        history: this.props.history,
                        location: this.props.location,
                    })
                } else {
                    await this.setState({
                        tab: tabs[0],
                    })
                }
            }

            const { tab, subscriptionId } = this.state
            await this.getProjects(tab, true)
            await this.getUserSubscriptionConstraints(subscriptionId)
        } catch (err) {
            console.error(err)
        } finally {
            if (this._isMounted) {
                await this.setState({
                    isLoading: false,
                })
            }
        }
    }

    async getUserSubscriptionConstraints(subscriptionId) {
        this.props.dispatch(
            USER__SET_SUBSCRIPTION_CONSTRAINTS(await API__USER.GET_SUBSCRIPTION_CONSTRAINTS(subscriptionId)),
        )
    }

    async getProjects(type, clear, resetPagination) {
        try {
            await this.setState(prevState => ({
                projects: {
                    ...prevState.projects,
                    [type]: {
                        ...prevState.projects[type],
                        isLoading: true,
                    },
                },
            }))

            let params = {}

            const {
                projects: {
                    [type]: { pagination, filter },
                },
            } = this.state

            // Pagination
            const newPagination = resetPagination ? this.baseState.projects[type].pagination : pagination

            params.perPage = newPagination.perPage
            params.offsetPages = newPagination.offsetPages
            // Filter
            params.status = filter.status
            params.sort = filter.sort

            const response1 = await API__PROJECTS.GET_PROJECTS(params)

            if (clear) {
                await this.setState(prevState => ({
                    projects: {
                        ...prevState.projects,
                        [type]: {
                            ...prevState.projects[type],
                            content: [],
                            pagination: newPagination,
                        },
                    },
                }))
            }

            await this.setState(prevState => ({
                projects: {
                    ...prevState.projects,
                    [type]: {
                        ...prevState.projects[type],
                        content: [...prevState.projects[type].content, ...response1.content],
                        pagination: {
                            ...prevState.projects[type].pagination,
                            totalPages: response1.totalPages,
                        },
                    },
                },
            }))
        } catch (err) {
            Toast('error', {})
            throw err
        } finally {
            if (this._isMounted) {
                await this.setState(prevState => ({
                    projects: {
                        ...prevState.projects,
                        [type]: {
                            ...prevState.projects[type],
                            isLoading: false,
                        },
                    },
                }))
            }
        }
    }

    async getProjectsCount() {
        try {
            const response1 = await API__PROJECTS.GET_PROJECTS_COUNT()

            await this.setState(prevState => ({
                projects: {
                    ...prevState.projects,
                    drafts: {
                        ...prevState.projects.drafts,
                        count: 0,
                    },
                    published: {
                        ...prevState.projects.published,
                        count: 0,
                    },
                },
            }))

            for (const el of response1) {
                switch (el.status) {
                    case 'DRAFT': {
                        await this.setState(prevState => ({
                            projects: {
                                ...prevState.projects,
                                drafts: {
                                    ...prevState.projects.drafts,
                                    count: el.count,
                                },
                            },
                        }))
                        break
                    }
                    case 'PUBLISHED': {
                        await this.setState(prevState => ({
                            projects: {
                                ...prevState.projects,
                                published: {
                                    ...prevState.projects.published,
                                    count: el.count,
                                },
                            },
                        }))
                        break
                    }
                    case 'DELETED': {
                        // На будущее мб что-то можно будет с этим придумать
                        break
                    }
                    default:
                        break
                }
            }
        } catch (err) {
            Toast('error', {})
            throw err
        }
    }

    async changeTab(target) {
        try {
            const { tab } = this.state
            if (target !== tab) {
                await this.getProjectsCount()
                await this.getProjects(target, true, true)

                UTILS__ROUTER__add_query('tab', target, {
                    history: this.props.history,
                    location: this.props.location,
                })

                await this.setState({
                    tab: target,
                })

                scroll.scrollToTop({
                    duration: 400,
                })
            }
        } catch (err) {
            console.error(err)
        }
    }

    tabClick = target => async evt => {
        evt.preventDefault()
        try {
            const { tab } = this.state
            if (target !== tab) {
                await this.getProjectsCount()
                await this.getProjects(target, true, true)

                UTILS__ROUTER__add_query('tab', target, {
                    history: this.props.history,
                    location: this.props.location,
                })

                await this.setState({
                    tab: target,
                })

                scroll.scrollToTop({
                    duration: 400,
                })
            }
        } catch (err) {
            console.error(err)
        }
    }

    editClick = project => evt => {
        evt.preventDefault()

        if (project.projectType.projectType === 'NEW_BLOCK_ARTICLE') {
            this.props.history.push(`/editor/${project.projectId}`)
        } else {
            this.props.history.push(`/account/editor?projectId=${project.projectId}&id=${project.id}`)
        }
    }

    deleteProject = project => async evt => {
        evt.preventDefault()
        try {
            await this.setState(prevState => ({
                modal: {
                    ...prevState.modal,
                    isLoading: true,
                },
            }))

            await API__PROJECTS.DELETE_PROJECT(project.projectId)

            switch (project.projectStatus) {
                case 'PUBLISHED': {
                    const {
                        projects: {
                            published: { content },
                        },
                    } = this.state
                    const itemIndex = content.findIndex(item => item.projectId === project.projectId)
                    if (itemIndex !== -1) {
                        let newContent = [...content]
                        newContent[itemIndex].isRemoved = true
                        await this.setState(prevState => ({
                            projects: {
                                ...prevState.projects,
                                published: {
                                    ...prevState.projects.published,
                                    content: newContent,
                                },
                            },
                        }))
                    }
                    break
                }
                case 'DRAFT': {
                    const {
                        projects: {
                            drafts: { content },
                        },
                    } = this.state
                    const itemIndex = content.findIndex(item => item.projectId === project.projectId)
                    if (itemIndex !== -1) {
                        let newContent = [...content]
                        newContent[itemIndex].isRemoved = true
                        await this.setState(prevState => ({
                            projects: {
                                ...prevState.projects,
                                drafts: {
                                    ...prevState.projects.drafts,
                                    content: newContent,
                                },
                            },
                        }))
                    }
                    break
                }
                default:
                    break
            }

            await this.setState(prevState => ({
                modal: {
                    ...prevState.modal,
                    isSuccess: true,
                },
            }))
        } catch (err) {
            console.error(err)
            if (this._isMounted) {
                await this.setState(prevState => ({
                    modal: {
                        ...prevState.modal,
                        isError: true,
                    },
                }))
            }
        } finally {
            if (this._isMounted) {
                await this.setState(prevState => ({
                    modal: {
                        ...prevState.modal,
                        isLoading: false,
                    },
                }))
            }
        }
    }

    duplicateProject = data => async evt => {
        evt.preventDefault()

        try {
            const { tab, actionLoading } = this.state

            if (!actionLoading.duplicateProject) {
                await this.setState(prevState => ({
                    actionLoading: {
                        ...prevState.actionLoading,
                        duplicateProject: true,
                    },
                }))

                const projectDetail = await API__PROJECTS.GET_PROJECT(data.projectId)

                const projectAction = projectDetail.projectActions.map(el => {
                    return {
                        ...el,
                        id: null,
                    }
                })
                const projectForms = projectDetail.projectForms.map(el => {
                    return {
                        ...el,
                        id: null,
                        fields: el.fields.map(el2 => {
                            return {
                                ...el2,
                                id: null,
                            }
                        }),
                    }
                })

                await API__PROJECTS.SAVE_PROJECT({
                    id: null,
                    projectId: uuidv4(),
                    projectType: {
                        id: data.projectType.id,
                    },
                    projectStructureJson: projectDetail.projectStructureJson,
                    projectAction,
                    projectForms,
                    name: `${data.name} (Duplicate)`,
                    title: data.title,
                    description: data.description,
                    imageId: data.imageId ? data.imageId : '',
                    imageUrl: data.imageUrl ? data.imageUrl : '',
                    customImageSelected: projectDetail.customImageSelected,
                    templateId: projectDetail.templateId,
                })

                if (tab !== 'drafts') {
                    await this.changeTab('drafts')
                } else {
                    await this.getProjectsCount()
                    await this.getProjects('drafts', true, true)
                    scroll.scrollToTop({
                        duration: 400,
                    })
                }

                await this.setState(prevState => ({
                    actionLoading: {
                        ...prevState.actionLoading,
                        duplicateProject: false,
                    },
                }))

                Toast('success', {
                    message: this.props.t('_pages._my_projects.project_duplicated'),
                })
            }
        } catch (err) {
            console.error(err)
            Toast('error', {})
        } finally {
            await this.setState({
                actionLoading: this.baseState.actionLoading,
            })
        }
    }

    openModal = (name, data) => async evt => {
        evt.preventDefault()
        if (name === 'delete_project') {
            await this.setState({
                deleteProjectAgreement: false,
            })
        }

        await this.setState({
            modal: {
                ...this.baseState.modal,
                isOpen: true,
                data,
                name,
            },
        })
    }

    closeModal = async evt => {
        evt.preventDefault()
        await this.setState(prevState => ({
            modal: {
                ...prevState.modal,
                isOpen: false,
            },
        }))
    }

    checkboxClick = (target, disabled) => async evt => {
        evt.preventDefault()
        try {
            if (!disabled) {
                await this.setState(prevState => ({
                    [target]: !prevState[target],
                }))
            }
        } catch (err) {
            console.error(err)
        }
    }

    openShareModal = project => async evt => {
        evt.preventDefault()

        let embedCode
        let iframeCode = ''
        if (project.projectType.projectType === PROJECT_TYPES.blockArticle) {
            embedCode = getProjectEmbedCodeWithLoader(project.projectVersions[0].versionHash)
            iframeCode = getProjectEmbedCodeWithIFrame(project.projectVersions[0].versionHash)
        } else {
            embedCode = getEmbedCodePlain(
                project.projectId,
                project.projectVersions[0].versionId,
                project.projectType.customId,
            )
        }

        await this.setState(prevState => ({
            shareModal: {
                ...prevState.shareModal,
                isOpen: true,
                data: {
                    ...prevState.shareModal.data,
                    projectUrl: project.projectVersions[0].publicUrl,
                    embedCode,
                    iframeCode,
                },
            },
        }))
    }

    openTrialModal = () => evt => {
        evt.preventDefault()

        this.setState({
            trialEndedModal: {
                isOpen: true,
            },
        })
    }

    closeDetachedModal = name => {
        this.setState({
            [name]: {
                ...this.baseState[name],
                isOpen: false,
            },
        })
    }

    paginationClick = type => async data => {
        try {
            await this.setState(prevState => ({
                projects: {
                    ...prevState.projects,
                    [type]: {
                        ...prevState.projects[type],
                        pagination: {
                            ...prevState.projects[type].pagination,
                            offsetPages: data.selected,
                        },
                    },
                },
            }))
            await this.getProjects(type, true)

            scroll.scrollToTop({
                duration: 400,
            })
        } catch (err) {
            console.error(err)
        }
    }

    updateUserTrial = async () => {
        const notification = this.state.userNotifications.find(obj =>
            [OLD_SUB_TO_TRIAL, NEW_SUB_TO_TRIAL].includes(obj.type),
        )
        await API__USER.RESET_TRIAL(this.state.userId)
        this.props.dispatch(USER__SET_SUBSCRIPTION(await API__USER.GET_SELECTED_SUBSCRIPTION(this.state.userId)))
        this.props.dispatch(USER__SET_TRIAL_COUNT(await API__USER.GET_TRIAL_COUNT(this.state.userId)))
        if (notification) {
            await API__USER.SET_NOTIFICATION_READ(notification.userId, notification.id)
        }
        this.props.dispatch(USER__SET_NOTIFICATIONS(await API__USER.GET_NOTIFICATIONS(this.state.userId)))
    }

    render() {
        const {
            language,
            t,
            user_subscription: userSubscription,
            user_notifications: userNotifications,
            user_trial_count: userTrialCount,
            user_details: userDetails,
            user_subscription_constraints: userSubscriptionConstraints,
        } = this.props
        const {
            isLoading,
            tab,
            projects,
            modal,
            deleteProjectAgreement,
            publishModal,
            shareModal,
            trialEndedModal,
            actionLoading,
            educationModal,
        } = this.state

        const viewsConstraints = {
            start: getMoment(userSubscription.constraintNextRenewalDate).subtract(1, 'M'),
            end: userSubscription.constraintNextRenewalDate,
            value:
                userSubscriptionConstraints.reviewsCount.featureProduct.productOptionValue -
                userSubscriptionConstraints.reviewsCount.currentValue,
            total: userSubscriptionConstraints.reviewsCount.featureProduct.productOptionValue,
        }

        const isTrialOrTrialEndedProduct = [TRIAL_PRODUCT_CODE, TRIAL_ENDED_PRODUCT_CODE].includes(
            userSubscription.product.productCode,
        )

        const showTrialProgress = userTrialCount ? userTrialCount.count > 0 && isTrialOrTrialEndedProduct : false

        const isTrial =
            userNotifications.find(obj => [OLD_SUB_TO_TRIAL, NEW_SUB_TO_TRIAL].includes(obj.type)) ||
            userSubscription.product.productCode === TRIAL_ENDED_PRODUCT_CODE

        const educationTransferNotification = userNotifications.find(obj => obj.type === OLD_SUB_TO_EDUCATION_FREE)

        const getTranslation = (customId, key) => {
            if (typeof types_translations[customId.toUpperCase()] !== 'undefined') {
                return types_translations[customId.toUpperCase()][key][language.split('-')[0]]
            }
            return ''
        }

        return !isLoading ? (
            <div className="page page--projects" data-structure="1">
                <Helmet>
                    <title>{t('_pages._my_projects.title')} | Interacty</title>
                </Helmet>

                <section>
                    <div className="container">
                        <div className="page-bar">
                            <div className="title">
                                <h1>{t('_pages._my_projects.title')}</h1>
                            </div>
                            <div className="tab">
                                <ul>
                                    <li
                                        className={`${tab === 'drafts' ? 'is-active' : ''}`}
                                        onClick={this.tabClick('drafts')}
                                    >
                                        {t('_pages._my_projects.drafts')}
                                        <span>•</span>
                                        {projects.drafts.count}
                                    </li>
                                    <li
                                        className={`${tab === 'published' ? 'is-active' : ''}`}
                                        onClick={this.tabClick('published')}
                                    >
                                        {t('_pages._my_projects.published')}
                                        <span>•</span>
                                        {projects.published.count}
                                    </li>
                                </ul>
                            </div>
                            <div className="actions">
                                <Link
                                    to={`/template-gallery`}
                                    className="button-style create-project-link"
                                    data-size="md"
                                    data-variant="primary-light"
                                    data-test="create-new-project"
                                >
                                    + {t('_common.create')}
                                </Link>
                            </div>
                        </div>
                        <TrialProgressBanner
                            isVisible={showTrialProgress}
                            isTrial={isTrial}
                            startDate={userSubscription.started}
                            expirationDate={userSubscription.expirationDate}
                            t={t}
                        />
                        {tab === 'drafts' && (
                            <DraftsTab
                                projects={projects}
                                t={t}
                                getTranslation={getTranslation}
                                actionLoading={actionLoading}
                                openModal={this.openModal}
                                editClick={this.editClick}
                                duplicateProject={this.duplicateProject}
                                paginationClick={this.paginationClick}
                                isTrial={isTrial}
                                openTrialModal={this.openTrialModal}
                            />
                        )}
                        {tab === 'published' && (
                            <PublishedTab
                                projects={projects}
                                t={t}
                                viewsConstraints={viewsConstraints}
                                getTranslation={getTranslation}
                                openModal={this.openModal}
                                editClick={this.editClick}
                                openShareModal={this.openShareModal}
                                duplicateProject={this.duplicateProject}
                                paginationClick={this.paginationClick}
                                actionLoading={actionLoading}
                                isTrial={isTrial}
                                isTrialOrTrialEndedProduct={isTrialOrTrialEndedProduct}
                                openTrialModal={this.openTrialModal}
                            />
                        )}
                    </div>

                    <DeleteProjectModal
                        modal={modal}
                        t={t}
                        deleteProjectAgreement={deleteProjectAgreement}
                        checkboxClick={this.checkboxClick}
                        closeModal={this.closeModal}
                        deleteProject={this.deleteProject}
                    />
                    <MobileActionsModal
                        modal={modal}
                        t={t}
                        actionLoading={actionLoading}
                        closeModal={this.closeModal}
                        openModal={this.openModal}
                        openShareModal={this.openShareModal}
                        duplicateProject={this.duplicateProject}
                    />
                </section>

                {trialEndedModal.isOpen ? (
                    <TrialEndedModal
                        t={t}
                        onClose={() => this.closeDetachedModal('trialEndedModal')}
                        notifications={userNotifications}
                        userId={userDetails.id}
                        userTrialCount={userTrialCount.count}
                    />
                ) : null}

                {educationModal.isOpen ? (
                    <TrialExtensionModal
                        isEducation={true}
                        isTransferred={true}
                        onClose={() => this.closeDetachedModal('educationModal')}
                        notification={educationTransferNotification}
                    />
                ) : null}

                {publishModal.isOpen ? (
                    <ShareProjectModal
                        title={publishModal.title}
                        data={publishModal.data}
                        onClose={() => this.closeDetachedModal('publishModal')}
                        isPublished
                    />
                ) : null}

                {shareModal.isOpen ? (
                    <ShareProjectModal
                        title={t('_pages._my_projects.share_your_project')}
                        data={shareModal.data}
                        onClose={() => this.closeDetachedModal('shareModal')}
                    />
                ) : null}
            </div>
        ) : (
            <Loader text="Projects loading..." />
        )
    }
}

const mapStateToProps = state => ({
    language: state.language,
    user_subscription: state.user_subscription,
    user_subscription_constraints: state.user_subscription_constraints,
    header_height: state._service.styles.header_height,
    user_notifications: state.user_notifications,
    user_details: state.user_details,
    user_trial_count: state.user_trial_count,
})

export default compose(connect(mapStateToProps, null), withTranslation('translations'))(MyProjects)
